import type { ComponentProps } from "react";

import type { PriceType } from "@features/ticket-card/model";

import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Body, Heading } from "@shared/ui/typography";
import { formatNumberWithSpaces } from "@shared/utils/string";

import s from "./price.module.scss";

export type PriceProps = ComponentProps<"div"> & {
  data: PriceType;
  onBuyClick?: () => void;
  hasLink: boolean;
};

export const Price = (props: PriceProps) => {
  const { data, hasLink, onBuyClick } = props;

  const hasAdultPrice =
    data?.adult?.newPrice !== null && data.adult?.newPrice !== undefined;
  const hasChildrenPrice =
    data?.childen?.newPrice !== null && data.childen?.newPrice !== undefined;

  if (!hasAdultPrice && !hasChildrenPrice) {
    return null;
  }

  return (
    <div className={s.root}>
      <div className={s.top}>
        {hasAdultPrice && (
          <div className={s.item}>
            <Body size="uppercase-small" weight="semiBold" className={s.adult}>
              Взрослый
            </Body>
            <div className={s.values}>
              <Heading level={5} tag="p">
                {formatNumberWithSpaces(data.adult.newPrice!)}
              </Heading>
              {data.adult.oldPrice &&
                data.adult.oldPrice > data.adult.newPrice! && (
                  <Body
                    size="uppercase-small"
                    weight="semiBold"
                    className={s.old}
                  >
                    {formatNumberWithSpaces(data.adult.oldPrice)}
                  </Body>
                )}
            </div>
          </div>
        )}
        {hasAdultPrice && hasChildrenPrice && <div className={s.line} />}
        {hasChildrenPrice && (
          <div className={s.item}>
            <Body size="uppercase-small" weight="semiBold" className={s.adult}>
              <span>Детский</span>
              <span>(6-13 лет)</span>
            </Body>
            <div className={s.values}>
              <Heading level={5} tag="p">
                {formatNumberWithSpaces(data.childen.newPrice!)}
              </Heading>
              {data.childen.oldPrice &&
                data.childen.oldPrice > data.childen.newPrice! && (
                  <Body
                    size="uppercase-small"
                    weight="semiBold"
                    className={s.old}
                  >
                    {formatNumberWithSpaces(data.childen.oldPrice)}
                  </Body>
                )}
            </div>
          </div>
        )}
      </div>
      <ButtonWithIcon
        variant="primary-dark"
        iconName="arrow"
        iconFillColor="cadmium"
        onClick={onBuyClick}
        disabled={!hasLink}
      >
        купить билет
      </ButtonWithIcon>
    </div>
  );
};

Price.displayName = "Price";
